export enum CriterionCalculateType {
  AVERAGE = 'AVERAGE'
}

export const CriterionCalculateTypeTranslation = {
  [CriterionCalculateType.AVERAGE]: 'średnia'
};

export const CriterionCalculateTypeList = [
  { value: CriterionCalculateType.AVERAGE, text: CriterionCalculateTypeTranslation[CriterionCalculateType.AVERAGE] }
];
